module.exports = __webpack_public_path__ + "images/4573248a25d8ecb131ff761f7e65d0b7.png";